/**
 * Created by User on 17/02/2016.
 */
import { AddonError, Plugin } from 'mggp-player';
import Observer from './utils/Observer';
import AdConsts from './AdConsts';
import LiveAdPlugin from './plugins/LiveAdPlugin';
import AdModel from './core/AdModel';
import VAST3ErrorTracker from './utils/VAST3ErrorTracker';
import VAST3ErrorCodes from './utils/VAST3ErrorCodes';
import Logger from './utils/Logger';
import AdURLModificator from './utils/AdURLModificator';
import PalSDK from "./utils/PalSDK";
import View from './core/View';

export default MggpPluginAd;

function MggpPluginAd(player, options){
  Plugin.apply(this, arguments);

  this.dispose = function() {
    _model.dispose();
    _customAdType = null;
    _prevPlayerState = -1;
    Observer.off([ AdConsts.BLOCK_STARTED, AdConsts.BLOCK_STARTING_NEW_ELEMENT, AdConsts.BLOCK_ENDED ], _onBlockListener);
    Observer.off([ AdConsts.AD_SKIN_VOLUME_CHANGED, AdConsts.AD_SKIN_MUTE_CHANGED, AdConsts.AD_SKIN_RESUME, AdConsts.AD_SKIN_PAUSE,
      AdConsts.AD_SKIN_CLICK_ON_BG, AdConsts.AD_SKIN_CLICK_ON_MESSAGE, AdConsts.AD_SKIN_SKIP_BUTTON, AdConsts.AD_SKIN_SKIP_MESSAGE ],
    _onSkinEvent);
    Observer.off([ AdConsts.MODEL_READY, AdConsts.MODEL_PLAYLIST_IS_EMPTY, AdConsts.MODEL_PLAYLIST_LOADING_ERROR,
      AdConsts.MODEL_PLAYLIST_PARSING_ERROR ], _onModelEvent);
    _player.off(AdConsts.AD_SHOW_ANOTHER_AD, onShowAnotherAd);
    _player.off(AdConsts.AD_PLAYER_ENDED, _onPlayerEnded);

    _player.off(AdConsts.PLAYER_EVENT_PROPERTY_POSITION, _onPlayerEvent);
    _player.off(AdConsts.PLAYER_EVENT_STATE_CHANGE, _onPlayerEvent);
    _player.off(AdConsts.PLAYER_EVENT_STOP, _onPlayerEvent);
    _player.off(AdConsts.SKIP_AD, _onSkipAdChange);
    window.removeEventListener('unload', _onUnload);
    _player.set('ad:showing', false);
    _player.set('ad:timeLabels', null);
    _player.set('postroll', false);
    _config = null;
    if (_currentMember) {
      // _completeCurrentMember();
      _stopCurrentBlock();
    }
  };

  var _onSkipAdChange = function (event) {
    if (event.data) {
      _stopCurrentBlock();
    }
  };

  this.load = function(src, videoInfo, params) {
    var isPlayerShouldContinueLoad = true;
		_isPlayerStopped = false;
    if (!videoInfo || videoInfo.rebinfo || (_config
				&& (_config.video_id === videoInfo.video_id || _config.src === videoInfo.src))) {
      if (LiveAdPlugin && LiveAdPlugin.isLiveAd) {
        LiveAdPlugin.resetStartTimestamp();
      }
      return;
    }
    _config = videoInfo;
    resetAd();
		PalSdk.start();

    //MHP-1866: иногда, к сожалению в этом месте _config === null, поскольку мог произойти player.stop()
    if (!_config || (!_config.advert_data && !_config.advert_url)) {
      Observer.emit(AdConsts.PLAYLIST_INFO, null);
      _player.set('preroll', false);
      return isPlayerShouldContinueLoad;
    } else if (_player.get('ad:skipAd')) {
      _player.set('preroll', false);
    } else {
      _player.set('preroll', true);
      isPlayerShouldContinueLoad = false;
    }

    _model.beginProcessAd(_config.advert_data, _config.advert_url, _player);
    return isPlayerShouldContinueLoad;
  };

  this.setAdlist = function (adlist) {
    resetAd();
    _player.set('preroll', false);
    _model.beginProcessAd(adlist);

  };

  //PRIVATES
  function resetAd() {
    _prevPlayerState = -1;
		_isPlayerStopped = false;
    if (_currentMember) {
      _stopCurrentBlock();
    }
    _player.set('postroll', false);
    if (_model) {
      _model.playlist.dispose();
      _customAdType = null;
    } else {
      _model = new AdModel();
    }
    _player.set('ad:timeLabels', null);
  }

  var onShowAnotherAd = function(event) {
		_isPlayerStopped = false;
    if (!event.data) {
      return;
    }
    var url = event.data.url,
      type = event.data.type;
    if (_currentMember) {
      // _completeCurrentMember();
      _stopCurrentBlock();
    }
    if (_model) {
      _model.playlist.dispose();
    } else {
      _model = new AdModel();
    }
    _player.set('postroll', false);
    _customAdType = type;
    _model.beginProcessAd(null, url);
  };

  var _onPlayerEvent = function(event) {
    var state;

    var info = _player.get('videoInfo');
    var currentTime = _player.get('position');
    var duration = _player.get('duration');
    var playlistItem = _player.get('playlist:item');
    if (playlistItem) {
      // Не нужно показывать рекламу на перебивках
      if (!playlistItem.root) {
        return;
      } else {
        currentTime -= playlistItem.start;
        duration = playlistItem.end - playlistItem.start;
      }
    }

    switch (event.name) {
      // case AdConsts.PLAYER_EVENT_MEDIA_BEFORE_COMPLETE:
      case AdConsts.PLAYER_EVENT_STOP:
				_isPlayerStopped = true;
        if (_currentMember) {
          // _completeCurrentMember();
          _stopCurrentBlock();
        }
        if (_model) {
          _model.playlist.dispose();
        }
        _player.set('postroll', false);
        _player.set('ad:showing', false);
        _player.set('ad:timeLabels', null);
				PalSdk.stop();
        _config = null;
        break;

      case AdConsts.PLAYER_EVENT_PROPERTY_POSITION:
        var playerState = _player.get('state');
        state = playerState === AdConsts.PLAYER_STATE_PLAYING ? AdConsts.STATE_PLAY : null;
        if (state) {
          _run(state, currentTime, duration);
        }
        if (_currentMember && !_currentMember.linear && duration - currentTime <= 5 && !info.is_live) {
          _stopCurrentBlock();
        }

        break;

      case AdConsts.PLAYER_EVENT_STATE_CHANGE:
        if (!_model.playlist.currentBlock
						&& (event.data == AdConsts.PLAYER_STATE_PLAYING || event.data == AdConsts.PLAYER_STATE_PAUSED)) {
          if (event.data == AdConsts.PLAYER_STATE_PLAYING && _prevPlayerState == AdConsts.PLAYER_STATE_PAUSED) {
            state = AdConsts.STATE_RESUME;
          } else if (event.data == AdConsts.PLAYER_STATE_PAUSED && _prevPlayerState == AdConsts.PLAYER_STATE_PLAYING) {
            state = AdConsts.STATE_PAUSE;
          }
          if (state) {
            _run(state, currentTime, duration);
          }
          _prevPlayerState = event.data;
        }
        break;
    }
  };

  var _onSkinEvent = function(event) {
    if (!_vendor) {
      return;
    }
    switch (event.name) {
      case AdConsts.AD_SKIN_VOLUME_CHANGED:
        _vendor.setVolume(event.data);
        _player.set('volume', event.data);
        _player.setVolume(event.data);
        if (event.data > 0) {
          _vendor.unMute();
          _player.set('muted', false);
          _player.unMute();
        }
        break;
      case AdConsts.AD_SKIN_MUTE_CHANGED:
        _vendor.setVolume(_player.get('volume'));
        if (event.data === true) {
          _vendor.mute();
          _player.mute();
          if (_currentMember) {
            _currentMember.track('mute');
          }
        } else if (event.data === false) {
          _vendor.unMute();
          _player.unMute();
          if (_currentMember) {
            _currentMember.track('unmute');
          }
        }
        _player.set('muted', event.data);
        break;
      case AdConsts.AD_SKIN_RESUME:
        if (_player.get('ad:vendor:state') !== 1) {
          _vendor.play();
          if (_currentMember) {
            _currentMember.track('resume');
          }
        }
        break;
      case AdConsts.AD_SKIN_PAUSE:
        if (_player.get('ad:vendor:state') !== 2) {
          _vendor.pause();
          if (_currentMember) {
            _currentMember.track('pause');
          }
        }
        break;
      case AdConsts.AD_SKIN_CLICK_ON_BG:
        if (_player.get('ad:vendor:state') !== 2) {
          _vendor.pause();
        }
        if (_currentMember) {
          _currentMember.track('click');
          _currentMember.track('pause');
        }
        if (player.config && player.config.deviceType === 'tv') {
          // _completeCurrentMember();
          _stopCurrentBlock();
        }
        break;
      case AdConsts.AD_SKIN_CLICK_ON_MESSAGE:
        if (_player.get('ad:vendor:state') !== 2) {
          _vendor.pause();
        }
        if (_currentMember) {
          _currentMember.track('click2');
          _currentMember.track('pause');
        }
        if (player.config && player.config.deviceType === 'tv') {
          // _completeCurrentMember();
          _stopCurrentBlock();
        }
        break;
      case AdConsts.AD_SKIN_SKIP_MESSAGE:
        if (_currentMember) {
          _currentMember.track('skip');
        }
        _completeCurrentMember();
        break;
      case AdConsts.AD_SKIN_SKIP_BUTTON:
        if (_currentMember) {
          _currentMember.track('skip2');
        }
        _completeCurrentMember();
        break;
    }
  };

  var _run = function(state, currentTime, duration) {
    if (_player.get('ad:disable')) return;
    _model.run(state, currentTime, duration, _player.get('sizeInfo'));
  };

  var _beginLoadMainContent = function() {
    _player.set('preroll', false);
		if(_isPlayerStopped) return;
		_player.load(_player.get('src'), _player.get('videoInfo'), _player.get('vendorOptions'));
  };

  var _onModelEvent = function(event) {
    if (_player.get('ad:disable')) return;
    switch (event.name) {
      case AdConsts.MODEL_READY:
        Observer.on([ AdConsts.BLOCK_STARTED, AdConsts.BLOCK_STARTING_NEW_ELEMENT, AdConsts.BLOCK_ENDED ], _onBlockListener);

        var postrollBlocks = _model.playlist.getBlockByType(AdConsts.POSTROLL);
        for (var i = 0, l = postrollBlocks.length; i < l; ++i) {
          if (postrollBlocks[i] && postrollBlocks[i].videoState == AdConsts.STATE_COMPLETE) {
            _player.set('postroll', true);
            break;
          }
        }

        if (_customAdType) {
          if (_customAdType == AdConsts.START_SCREEN) {
            _model.playlist.run(AdConsts.STATE_PLAY, 0, 1, AdConsts.START_SCREEN);
          }
          break;
        }

        _processAdTimeLabels();
        if (_player.get('position') < 1) {
          if (_model.hasPreroll) {

            var advertData = _player.get('videoInfo').advert_data;
            if (typeof advertData !== 'string') advertData = JSON.stringify(advertData);
            // var timeout = advertData && advertData.indexOf('zskip') !== -1 ? 300 : 0;

            setTimeout(function() {
              _run(AdConsts.STATE_PLAY, 0, 1);
            }, 300);

          } else if (!_player.get(AdConsts.SKIP_AD)) {
            _beginLoadMainContent();
          }
        }
        break;
      case AdConsts.MODEL_PLAYLIST_IS_EMPTY:
      case AdConsts.MODEL_PLAYLIST_LOADING_ERROR:
      case AdConsts.MODEL_PLAYLIST_PARSING_ERROR:
        _beginLoadMainContent();
        break;
    }
  };

  var _onBlockListener = function(event) {
    switch (event.name) {
      case AdConsts.BLOCK_STARTED:
        _blockStartedDefactoFired = false;
        break;

      case AdConsts.BLOCK_STARTING_NEW_ELEMENT:
        if (_model && _model.playlist && _model.playlist.currentBlock && _model.playlist.currentBlock.currentMember) {
          _currentMember = _model.playlist.currentBlock.currentMember;
          var extension = _currentMember.mediaFileExtension;
          if (_currentMember.element && _currentMember.element.vastData && _currentMember.element.vastData.mediaFile) {
            var mediaFile = _currentMember.element.vastData.mediaFile;
            if (mediaFile.length > 0) {
              mediaFile = mediaFile[0];
              if (mediaFile.apiFramework == 'VPAID' && extension != 'js') {
                extension = 'vpaid';
              }
            }
          }

          var vendorClass = _player.getVendor(extension, { isDrm: false, advertPlaying: true });
          if (vendorClass) {
            _vendor = new vendorClass(_player, {});
            Observer.on([ AdConsts.VENDOR_STATE_CHANGE, AdConsts.VENDOR_MEDIA_ERROR, AdConsts.VENDOR_ERROR, AdConsts.VENDOR_EVENT_PROPERTY_POSITION ], _onVendorEvent);
            var options = _createOptions(_currentMember);
            _player.set('ad:showing', true);
            _player.set('ad:vendor:volume', _player.get('muted') ? 0 : _player.get('volume'));
            _player.set('ad:vendor:muted', false);

            if (_currentMember.element && _currentMember.element.vastDocument) {
              var skipTracking = _currentMember.mediaFileExtension == "ima" ||
								(_currentMember.element.apiFramework && _currentMember.element.apiFramework.toUpperCase() === 'VPAID');
              if (!skipTracking) {
                _currentMember.element.vastDocument.sendReadyEvents();
              }
            }

            _vendor.load(_currentMember.mediaFileUrl, null, options);
            if (_contentTimeoutID != null) {
              clearTimeout(_contentTimeoutID);
            }
            Observer.emit(AdConsts.MEDIA_BEGINS_LOADING);
            if (_currentMember.mediaFileUrl.indexOf(AdConsts.ADTELLIGENT_HOST) !== -1) {
              Observer.emit(AdConsts.MEDIA_ADT_BEGINS_LOADING);
            }

            _contentTimeoutID = setTimeout(_onContentTimeout, 15000);
          } else {
            var url = _currentMember.mediaFileUrl;
            if (AddonError) {
              var errorType = AddonError.errorTypes.PLAYBACK_ERROR;
              var errorCode = AddonError.errorCodes[errorType].MEDIA_FILE_IS_NOT_SUPPORTED;
              var errorMessage = AddonError.errorMessages[errorCode] + url;
              new AddonError(Observer.getObserverInstance(), errorType, errorCode, errorMessage);
            }

            Observer.emit(AdConsts.CANNOT_FIND_VENDOR);
            VAST3ErrorTracker.track(VAST3ErrorCodes.PLAYER_CANNOT_DISPLAY);
            _completeCurrentMember(true, 'cannot find vendor');
          }
        }
        break;

      case AdConsts.BLOCK_ENDED:
        if (event.data) {

          if (event.data.type === AdConsts.PREROLL && _model && _model.playlist && !_model.playlist.disposed) {
            _beginLoadMainContent();
          } else if (event.data.type === AdConsts.START_SCREEN) {
            //do nothing
          } else if (event.data.linear && event.data.type != AdConsts.PAUSE_ROLL && event.data.videoState != AdConsts.STATE_COMPLETE) {
            _player.play();
          } else if (event.data.videoState == AdConsts.STATE_COMPLETE) {
            _player.emit('player:completed');
          }
        }
        _player.set('ad:showing', false);
        break;
    }
  };

  var _onVendorEvent = function(event) {
    if (_player.get('ad:disable')) return;
    switch (event.name) {
      case AdConsts.VENDOR_STATE_CHANGE:
        var state = _player.get('ad:vendor:state');
        var skipTracking;
        switch (state) {
          case AdConsts.PLAYER_STATE_PLAYING:
            if (_contentTimeoutID) {
              clearTimeout(_contentTimeoutID);
              _contentTimeoutID = null;

              if (_currentMember && _currentMember.element && _currentMember.element.vastDocument) {
                skipTracking = _currentMember.element.apiFramework && _currentMember.element.apiFramework.toUpperCase() === 'VPAID';
                if (!skipTracking) {
                  _currentMember.element.vastDocument.sendStartEvent();
                }
              }

              if (!_blockStartedDefactoFired) {
                Observer.emit(AdConsts.BLOCK_STARTED_DE_FACTO, _currentMember);
                _blockStartedDefactoFired = true;
              }
              Observer.emit(AdConsts.MEMBER_STARTED_DE_FACTO, _currentMember);
              if (_currentMember && _currentMember.linear && !_player.isSinglePlayer) {
                _player.pause();
                // на вебосе 15го года _vendor почему-то становится на паузу, поэтому передергиваем так
                _vendor.pause();
                setTimeout(function() {
                  _vendor.play();
                }, 0);
              }
            }
            break;
          case AdConsts.PLAYER_STATE_ENDED:
            //Logger.log('ad:vendor:state -> ended');
            _completeCurrentMember();
            break;
          case AdConsts.PLAYER_STATE_BUFFERING:
            if (_currentMember && _currentMember.element && _currentMember.element.vastDocument) {
              skipTracking = _currentMember.element.apiFramework && _currentMember.element.apiFramework.toUpperCase() === 'VPAID';
              if (!skipTracking) {
                _currentMember.element.vastDocument.sendStartEvent();
              }
            }
            break;
        }
        break;
      case AdConsts.VENDOR_EVENT_PROPERTY_POSITION:
        if (_currentMember) {
          skipTracking = _currentMember.element && _currentMember.element.apiFramework && _currentMember.element.apiFramework.toUpperCase() === 'VPAID';

          var position = Math.round(_player.get('ad:vendor:position'));
          var duration = Math.round(_player.get('ad:vendor:duration'));
          if (!skipTracking) {
            _currentMember.track('onTime', [ position, duration ]);
          }
        }
        break;
      case AdConsts.VENDOR_MEDIA_ERROR:
      case AdConsts.VENDOR_ERROR:
        if (_contentTimeoutID) {
          clearTimeout(_contentTimeoutID);
        }
        VAST3ErrorTracker.track(VAST3ErrorCodes.COUDNT_DISPLAY_MEDIAFILE);
        Observer.emit(AdConsts.MEDIAFILE_VENDOR_ERROR);
        _completeCurrentMember(true, 'vendor error');
        break;
    }
  };

  var _onPlayerEnded = function(event) {
    if (_player.get('ad:disable')) return;
    var duration = _player.get('duration');
    _model.playlist.run(AdConsts.STATE_COMPLETE, duration, duration, AdConsts.POSTROLL);
  };

  var _completeCurrentMember = function(isError, reason) {
    Observer.off([ AdConsts.VENDOR_STATE_CHANGE, AdConsts.VENDOR_MEDIA_ERROR, AdConsts.VENDOR_ERROR, AdConsts.VENDOR_EVENT_PROPERTY_POSITION ], _onVendorEvent);
    //we don't know, container in view had created or had not created, we must 100% remove it from DOM
    _view.removeCurrentContainer();

    // var name = '';
    // try {
    //   if (isError) {
    //     name = _vendor.__proto__.constructor.name;
    //   }
    // } catch (error) {

    // }

    if (_vendor) {
      _vendor.stop();
      _vendor = null;
    }

    if (isError && _currentMember) {
      // Observer.emit('kibana:warning', {
      // 	"message": reason + '; ' + name,
      // 	"type": 'testEvent',
      // 	'code': 'vastError',
      // 	'appVersion': AdConsts.APP_VERSION
      // });

      _currentMember.failed = true;
      if (_currentMember.element && _currentMember.element.vastDocument) {
        _currentMember.element.vastDocument.error();
      }
    }
    _model.currentMemberCompleted();
    _currentMember = null;
  };

  var _stopCurrentBlock = function() {
    Observer.off([ AdConsts.VENDOR_STATE_CHANGE, AdConsts.VENDOR_MEDIA_ERROR, AdConsts.VENDOR_ERROR, AdConsts.VENDOR_EVENT_PROPERTY_POSITION ], _onVendorEvent);
    _view.removeCurrentContainer();
    if (_vendor) {
      _vendor.stop();
      _vendor = null;
    }
    if (_model) {
      _model.stopCurrentBlock();
    }
    _currentMember = null;
  };

  var _onContentTimeout = function() {
    _contentTimeoutID = null;
    Observer.emit(AdConsts.MEDIAFILE_TIMEOUT, _currentMember);
    VAST3ErrorTracker.track(VAST3ErrorCodes.MEDIAFILE_URI_TIMEOUT);
    _completeCurrentMember(true, 'timeout');
  };

  var _onUnload = function(event) {
    Observer.emit(AdConsts.PAGE_CLOSING);
  };

  var _createOptions = function(member) {
    var options = { namespace: 'ad:vendor:', autoplay: true };
    var extension = member.mediaFileExtension;

    options.type = member.type;

    if (extension === 'ima') {
      options.container = _view.createIMAContainer();
      options.vastDocument = _currentMember.element.vastDocument;
    } else {
      if (!member.linear) {
        options.container = _view.createOverlayContainer(member);
      } else {
        options.container = _view.parentContainer;
      }
      if ([ 'jpg', 'jpeg', 'gif', 'png', 'html', 'htm' ].indexOf(extension) != -1) {
        options.duration = _currentMember.vastDataDuration || 10;
      } else if ([ 'swf', 'vpaid' ].indexOf(extension) != -1) {
        options.vastDocument = _currentMember.element.vastDocument;
      } else if (extension == 'js') {
        if (_currentMember.element.vastDocument.vastData['adparameters'] && _currentMember.element.vastDocument.vastData['adparameters'].length > 0) {
          options.adParameters = _currentMember.element.vastDocument.vastData['adparameters'][0];
        }
        options.vastDocument = _currentMember.element.vastDocument;
        options.container = _view.parentContainer;
      }
    }
    return options;
  };

  var _processAdTimeLabels = function() {
    var duration = _player.get('duration');
    if (duration == 0) {
      _player.on('property:duration', createAdTimeLabels);
    } else {
      createAdTimeLabels();
    }

    function createAdTimeLabels() {
      if (duration == 0) {
        duration = _player.get('duration');
      }
      var timeLabels = [];
      var blocks = _model.playlist.blocks;
      var playlistInfo = _player.get('playlist:info');
      var startOffset = 0;

      if (playlistInfo) playlistInfo.items.forEach(function(item) {
        if (item.root) startOffset = item.start;
      });

      if (blocks) {
        for (var i = 0, l = blocks.length; i < l; ++i) {
          if (blocks[i].type === AdConsts.OVERLAY || blocks[i].type === AdConsts.MIDROLL || blocks[i].type === AdConsts.POSTROLL) {
            timeLabels.push({
              'type': blocks[i].type,
              'time': getStartTime(blocks[i]) + startOffset
            });
          }
        }
      }
      _player.set('ad:timeLabels', timeLabels);
    }

    function getStartTime(member) {
      var result = -1;
      if (member) {
        if (member.timeUnit === AdConsts.PERCENT) {
          result = duration * member.timeStart / 100;
        } else if (member.timeUnit === AdConsts.SECONDS) {
          result = member.timeStart;
        }
      }
      return result;
    }
  };

  AdConsts.DEVICE_TYPE = player.config.deviceType;
  AdConsts.PROTOCOL = player.config.protocol;
  AdConsts.APP_VERSION = player.config.appVersion;

  var _vendor = null;
  var _prevPlayerState = -1;
  var _contentTimeoutID = null;
  var _currentMember = null;
  var _blockStartedDefactoFired = false;
  var _model = null;
  var _config = null;
  var _customAdType = null;
  var _player = player;
  var _plugins = [];
	var _isPlayerStopped = false;

  if (AdConsts.DEVICE_TYPE != 'tv') {
    _plugins.push(new LiveAdPlugin(this));
  }

  var parentContainer;
  if (options && options.adContainer) {
    parentContainer = options.adContainer;
  } else {
    parentContainer = player.parentContainer;
  }
  var _view = new View(parentContainer);
	var PalSdk = new PalSDK(player);

  if (player) {
    Logger.initialize(player.utils.log);
    AdURLModificator.initialize(player.config.href, player);
		PalSdk.init();

    Observer.initialize(player);
    Observer.on([ AdConsts.MODEL_READY, AdConsts.MODEL_PLAYLIST_IS_EMPTY, AdConsts.MODEL_PLAYLIST_LOADING_ERROR,
      AdConsts.MODEL_PLAYLIST_PARSING_ERROR ], _onModelEvent);
    Observer.on([ AdConsts.AD_SKIN_VOLUME_CHANGED, AdConsts.AD_SKIN_MUTE_CHANGED, AdConsts.AD_SKIN_RESUME, AdConsts.AD_SKIN_PAUSE,
      AdConsts.AD_SKIN_CLICK_ON_BG, AdConsts.AD_SKIN_CLICK_ON_MESSAGE, AdConsts.AD_SKIN_SKIP_BUTTON, AdConsts.AD_SKIN_SKIP_MESSAGE ],
    _onSkinEvent);
    player.on(AdConsts.AD_SHOW_ANOTHER_AD, onShowAnotherAd);
    player.on(AdConsts.AD_PLAYER_ENDED, _onPlayerEnded);
    player.on(AdConsts.PLAYER_EVENT_PROPERTY_POSITION, _onPlayerEvent);
    player.on(AdConsts.PLAYER_EVENT_STATE_CHANGE, _onPlayerEvent);
    player.on(AdConsts.PLAYER_EVENT_STOP, _onPlayerEvent);
    player.on(AdConsts.SKIP_AD, _onSkipAdChange);

  }
  window.addEventListener('unload', _onUnload, false);

  _player.set('ad:showing', false);
  _player.registerProperty(AdConsts.SKIP_AD, false, true);

}
MggpPluginAd.prototype.constructor = MggpPluginAd;
